// GENERATED FILE -- do not edit by hand.
// Regenerate with `npm run codegen:stores` (see frontend/package.json).
// Source: agent.app.ssh_keys_catalog.SSHKey

import { makeObservable, observable } from "mobx";
import { applyJsonPatch, JsonPatchOp } from "@/app_store/rpc/json_patch";
import { AgentTransport, callRpc } from "@/app_store/rpc/rpc";
import { registerEntity, wrapEntity } from "@/app_store/rpc/entity";

export interface SSHKeyData {
    // Stamped onto every @observable model's dump at runtime (see
    // common._ObservableMixin._serialize_with_tag) -- tells wrapEntity which
    // generated Store class this value belongs to. Never sent by a client.
    _entity_class_name: "SSHKey";
    id: string;
    name: string;
    public_key: string;
    private_key: string;
}

export class SSHKeyStore {
    readonly _entity_class_name = "SSHKey" as const;
    id: string;
    name: string;
    public_key: string;
    private_key: string;
    private _transport: AgentTransport;
    private _chainPath: string[];

    constructor(data: SSHKeyData, transport: AgentTransport, chainPath: string[] = []) {
        this._transport = transport;
        this._chainPath = chainPath;
        this.id = wrapEntity(data.id, transport, [...chainPath, "id"]);
        this.name = wrapEntity(data.name, transport, [...chainPath, "name"]);
        this.public_key = wrapEntity(data.public_key, transport, [...chainPath, "public_key"]);
        this.private_key = wrapEntity(data.private_key, transport, [...chainPath, "private_key"]);
        makeObservable(this, {
            id: observable,
            name: observable,
            public_key: observable,
            private_key: observable,
        });
    }

    applyPatch(op: JsonPatchOp): void {
        applyJsonPatch(this, op);
    }

    async get_private_key(): Promise<any> {
        return callRpc(this._transport, this._chainPath, "get_private_key", [], {});
    }
}

registerEntity("SSHKey", SSHKeyStore);
